import api from '../api';
import { defaultFetchConfig } from '../config';
import ranchApi from '../ranchApi';

export const fetchAllFieldDetails = async (params = {}) => {
  const { data = [] } = await ranchApi.get(`/admin/fields`, {
    params: { ...defaultFetchConfig, ...params }
  });
  return data;
};

export const fetchAllMetricData = async (params = {}) => {
  try {
    const { data = {} } = await ranchApi.get(`/admin/project/metrics`, {
      params
    });
    return data;
  } catch (error) {
    console.error('fetchAllMetricData error:', error);
    throw error;
  }
};
export const fetchFieldById = async (params = {}) => {
  try {
    const { data = [] } = await ranchApi.get('getFieldById', {
      params
    });
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

export const fetchAllProducers = async (params = {}) => {
  try {
    const { data = [] } = await ranchApi.get(`/getAllProducers`, {
      params
    });
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

export const fetchBankDocEnum = async (params = {}) => {
  try {
    const { data = [] } = await api.get(
      `/enum/values?type=bank_document_type`,
      {
        params
      }
    )
    return data;
  } catch (error) {
    console.log(JSON.stringify(error), 'error');
    throw error;
  }
};

